import React from 'react'
import WindowWithTeams from './WindowWithTeams'
import Button from './StyledComponents'

export default function ShowTeams() {
    return (
        <div className="show-teams">
            <WindowWithTeams/>
        </div>
    )
}
